export default "__VITE_ASSET__DLGsO_i9__"